const FIVE_MINUTES_IN_MS = 15 * 60 * 1000
export const getVisitedRecently = (visitedAt?: string): boolean =>
  !!visitedAt && Date.now() - new Date(visitedAt).getTime() < FIVE_MINUTES_IN_MS
